module.exports = __webpack_public_path__ + "assets/hide-d51accc1756c537adec4e225e89ee772.svg";